import {
    accountIcon, githubIcon,
    makeImportIcon,
    makeCalcIcon,
    makeKofiIcon,
    makePatreonIcon,
    mySheetsIcon,
    makeNewSheetIcon, settingsIcon
} from "./icons";

export function applyCommonTopMenuFormatting(link: HTMLAnchorElement) {
    if (link.getAttribute('formatted') === 'true') {
        return;
    }
    switch (link.textContent) {
        case 'My Sheets':
            link.replaceChildren(mySheetsIcon(), textSpan(link.textContent));
            link.title = 'View your saved sheets';
            break;
        case 'New Sheet':
            link.replaceChildren(makeNewSheetIcon(), textSpan(link.textContent));
            link.title = 'Create a new sheet from scratch';
            break;
        case 'Import':
            link.replaceChildren(makeImportIcon(), textSpan(link.textContent));
            link.title = 'Import sheets, sets, or Etro links into a new sheet';
            break;
        case 'GitHub':
            link.replaceChildren(githubIcon());
            link.title = 'Source code on GitHub';
            break;
        case 'Settings':
            link.replaceChildren(settingsIcon());
            link.title = 'Light mode, theme, and other settings.';
            break;
        case 'Math':
            link.replaceChildren(makeCalcIcon());
            link.title = 'Math center';
            break;
        case 'Ko-Fi':
            link.replaceChildren(makeKofiIcon());
            link.title = 'Donate on Ko-Fi';
            break;
        case 'Patreon':
            link.replaceChildren(makePatreonIcon());
            link.title = 'Donate on Patreon';
            break;
        default:
            if (link.id === 'account-button') {
                link.replaceChildren(accountIcon(), ...link.querySelectorAll('span'));
                break;
            }
    }
    link.setAttribute('formatted', 'true');
}

function textSpan(text: string) {
    const span = document.createElement('span');
    span.textContent = text;
    return span;
}

